import { gql } from 'react-apollo'
const submitRegistrationMutation = gql`
  mutation submitRegistration($_id: MongoID!) {
    submitRegistration(_id: $_id) {
      _id
      eventId
      registrationTypeId
      status
    }
  }
`
export default submitRegistrationMutation



// WEBPACK FOOTER //
// ./src/App/graphql/mutations/submitRegistration.js